'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PageWrapper = require('../../../../common/components/layout/PageWrapper.js');
var Button = require('@narvar/nth-block-button');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var DesktopWorkflowContent = require('../../../../common/components/layout/DesktopWorkflowContent.js');
var ItemAdditionalInfoForm = require('../../../../common/views/ItemAdditionalInfo/ItemAdditionalInfoForm/ItemAdditionalInfoForm.js');
var ItemCardClaims = require('../../../../common/components/ItemCardClaims.js');
var SecondaryButton = require('../../../../common/components/SecondaryButton.js');
var ItemAdditionalInfoProvider = require('../../../../common/views/ItemAdditionalInfo/ItemAdditionalInfoProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);

const ItemAdditionalInfoDesktop = () => {
  const {
    claimsButtonBack,
    claimsButtonNext,
    claimsAdditionalInfoTitle
  } = nthHookTranslations.useTranslations();
  const {
    canProceed,
    itemDetails,
    claimDetails,
    onSubmit,
    onBack
  } = ItemAdditionalInfoProvider.useItemAdditionalInfo();
  return /*#__PURE__*/React__default["default"].createElement(PageWrapper["default"], null, /*#__PURE__*/React__default["default"].createElement(DesktopWorkflowContent.DesktopWorkflowContent, null, /*#__PURE__*/React__default["default"].createElement(DesktopWorkflowContent.DesktopWorkflowContentLeft, null, /*#__PURE__*/React__default["default"].createElement(ItemCardClaims["default"], {
    itemDetails: itemDetails,
    claimDetails: claimDetails,
    layout: "vertical"
  })), /*#__PURE__*/React__default["default"].createElement(DesktopWorkflowContent.DesktopWorkflowContentRight, null, /*#__PURE__*/React__default["default"].createElement(DesktopWorkflowContent.DesktopWorkflowContentHeader, null, claimsAdditionalInfoTitle), /*#__PURE__*/React__default["default"].createElement(ItemAdditionalInfoForm["default"], null), /*#__PURE__*/React__default["default"].createElement(DesktopWorkflowContent.DesktopWorkflowContentActionButtonsContainer, null, /*#__PURE__*/React__default["default"].createElement(SecondaryButton["default"], {
    big: true,
    onClick: onBack
  }, claimsButtonBack), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    big: true,
    disabled: !canProceed,
    onClick: onSubmit
  }, claimsButtonNext)))));
};
var ItemAdditionalInfoDesktop$1 = nthHookTranslations.withTranslationsProvider(ItemAdditionalInfoDesktop, {
  translationKeys: ['claimsButtonBack', 'claimsButtonNext', 'claimsAdditionalInfoTitle']
});

exports["default"] = ItemAdditionalInfoDesktop$1;
